import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../../context/AppContext";
import ProductDetails from "../../../../user/pages/standard/pages/shop/components/ProductDetails";

export default function GetAITokens({ guestEmail, phoneId, licenceKey, mentorId }) {
    const navigate = useNavigate();
    const { appData } = useAppContext();

    return (
        <div className="container py-5 d-flex flex-column justify-content-between">
            <div className="card shadow-lg">
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h3 className="mb-0 text-white">{appData?.name} AI Tokens</h3>

                    <button className="btn btn-light btn-sm text-primary" onClick={() => navigate(-1)}>
                        <i className="fa fa-arrow-left me-2"></i>
                        Back
                    </button>
                </div>

                <div className="row">
                    <h4 className="text-center fw-bold my-3">Buy AI Tokens</h4>
                    <p className="text-center mb-4">
                        Purchase AI Tokens to spend inside the app. <strong>{appData?.name}</strong>
                    </p>

                    <ProductDetails
                        slug={"ai-tokens"}
                        loggedInUserData={{ user: { email: guestEmail }, metadata: { phoneId, licenceKey, mentorId } }}
                    />
                </div>
            </div>

            <footer className="text-center mt-5 small text-muted">
                &copy; {appData?.name} {new Date().getFullYear()} &nbsp; | &nbsp;
                <Link to="/legal" className="text-muted">Legal</Link>
                &nbsp; | &nbsp; <Link to="/help" className="text-muted">Help</Link>
            </footer>
        </div>
    );
}
